import { useState } from 'react';
import { Card, CardBody, CardHeader, CardTitle, PageHeader } from '@nexply/ui';

interface FAQ {
  q: string;
  a: string;
}

const FAQS: FAQ[] = [
  {
    q: 'Wie funktionieren Matches?',
    a: 'Matches werden auf Basis deiner Mitglieder-Profile, Tags, Branchen sowie Angebot/Suche generiert. Du kannst Vorschläge für jedes Mitglied einsehen und manuell als verbunden oder verworfen markieren.',
  },
  {
    q: 'Wie pflege ich Telefon-Kontakte ein?',
    a: 'Unter „Telefon-Kontakte" lädst du deine Kontakte (vCard/CSV) hoch, gehst sie einzeln durch und übernimmst nur die, die wirklich ins Netzwerk gehören. Erkannte Verbindungen kannst du direkt bestätigen.',
  },
  {
    q: 'Was macht die Smart Search?',
    a: 'Du beschreibst in normaler Sprache, wen du suchst („Steuerberater in München, der Startups betreut") — die Suche gleicht das mit Profilen, Tags, Branchen und Angebot/Suche deiner Mitglieder ab.',
  },
  {
    q: 'Wie exportiere ich meine Daten?',
    a: 'Unter „Backup“ kannst du jederzeit ein vollständiges JSON-Backup all deiner Daten herunterladen und später wieder einspielen (Zusammenführen oder Ersetzen).',
  },
  {
    q: 'Wie ändere ich meine E-Mail oder mein Passwort?',
    a: 'Beides ist unter „Einstellungen“ möglich. Beim Passwort-Wechsel ist das aktuelle Passwort zur Bestätigung nötig.',
  },
];

function Accordion({ items }: { items: FAQ[] }) {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <div className="divide-y divide-line border border-line rounded-lg overflow-hidden">
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={i}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left bg-raise hover:bg-raise-2 transition"
            >
              <span className="text-sm text-text">{it.q}</span>
              <span className={`text-text-muted transition-transform ${isOpen ? 'rotate-180' : ''}`}>▾</span>
            </button>
            {isOpen && (
              <div className="px-4 py-3 text-sm text-text-dim bg-raise">
                {it.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export function HelpPage() {
  return (
    <div className="max-w-3xl space-y-6">
      <PageHeader
        title="Hilfe & FAQ"
        subtitle="Schnellstart, häufige Fragen und Kontakt zum Support."
      />

      <Card>
        <CardHeader>
          <CardTitle>Schnellstart</CardTitle>
        </CardHeader>
        <CardBody className="pt-0">
          <ol className="space-y-2 text-sm text-text-dim list-decimal list-inside">
            <li>Eigenes Business-Profil unter „Mein Profil“ ausfüllen.</li>
            <li>Erste Mitglieder im Mitglieder-Modul anlegen oder importieren.</li>
            <li>Telefon-Kontakte einpflegen und Verbindungen bestätigen.</li>
            <li>Matches generieren – pro Mitglied passende Verbindungen finden.</li>
            <li>Karte und Smart Search nutzen, um im Netzwerk gezielt zu finden.</li>
          </ol>
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Häufige Fragen</CardTitle>
        </CardHeader>
        <CardBody className="pt-0">
          <Accordion items={FAQS} />
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Support & Feedback</CardTitle>
        </CardHeader>
        <CardBody className="pt-0 space-y-2 text-sm text-text-dim">
          <p>
            Bei Fragen oder Problemen schreib uns gerne an{' '}
            <a className="text-gold-light underline" href="mailto:support@nexply.app">
              support@nexply.app
            </a>
            .
          </p>
          <p>Feedback und Feature-Wünsche helfen uns, Nexply besser zu machen.</p>
        </CardBody>
      </Card>
    </div>
  );
}
